import type { Block } from "@aswin.dev/types";

function isDomNode(value: unknown): boolean {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && value instanceof HTMLElement) {
    return true;
  }
  if (typeof Node !== "undefined" && value instanceof Node) {
    return true;
  }
  return (
    "nodeType" in value &&
    typeof (value as { nodeType: unknown }).nodeType === "number"
  );
}

/** True when value looks like a template block (not a dragged DOM node). */
export function isBlock(value: unknown): value is Block {
  if (typeof value !== "object" || value === null || isDomNode(value)) {
    return false;
  }
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.id === "string" && typeof candidate.type === "string"
  );
}

/** Drops non-block entries that vuedraggable can accidentally emit. */
export function filterBlockList(values: unknown[]): Block[] {
  return values.filter(isBlock);
}

export function filterSectionChildren(children: unknown): Block[][] {
  if (!Array.isArray(children)) {
    return [];
  }
  return children.map((column) =>
    Array.isArray(column) ? filterBlockList(column) : [],
  );
}

/** Sanitizes partial block updates before merging into editor state. */
export function sanitizeBlockUpdates(updates: Partial<Block>): Partial<Block> {
  if (!("children" in updates) || updates.children === undefined) {
    return updates;
  }

  return {
    ...updates,
    children: filterSectionChildren(updates.children),
  };
}
